import React from 'react';

import { GridFilterItem, GridFilterOperator } from '@mui/x-data-grid';

import styled from 'styled-components';

import { MenuItem } from '@mui/material';

import { colors } from 'theme/colors';
import { StyledSelect } from 'components/Input/styles';

import { createFilterRegex } from 'utils/regex';
import { PickerProps } from 'components/Grid/operators/types';

export const StyledMenuItem = styled(MenuItem)`
  color: ${colors.legacy.grey[200]};
  font-size: 1.3rem;
  line-height: 2rem;
  p {
    margin: 0;
  }
`;

const ActiveFilterOperator: React.FunctionComponent<PickerProps> = ({ applyValue, item, ...props }) => (
  <StyledSelect
    {...props}
    value={item.value}
    fullWidth
    onChange={(newValue) => applyValue({ ...item, value: newValue.target.value })}
  >
    <StyledMenuItem key="active" value="true">
      <p>Active</p>
    </StyledMenuItem>
    <StyledMenuItem key="inactive" value="false">
      <p>Inactive</p>
    </StyledMenuItem>
  </StyledSelect>
);

export default (): GridFilterOperator[] =>
  [
    {
      label: 'is',
      value: 'is',
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (!filterItem.value) {
          return null;
        }
        const filterRegex = createFilterRegex(filterItem.value);
        return ({ value }: { value: string }): boolean => (value != null ? filterRegex.test(value.toString()) : false);
      },
      InputComponent: ActiveFilterOperator,
      InputComponentProps: { value: null },
      getValueAsString: (value: string) => value,
    },
  ] as unknown as GridFilterOperator[];
